<template>
    <section class="requirements">
        <header class="requirements__header">
            <h1>Технические требования</h1>
            <p>Выберите организацию, чтобы увидеть конкретные требования.</p>
        </header>

        <div class="requirements__controls">
            <label class="control">
                <span>Организация</span>
                <select v-model="selectedOid" @change="loadRequirements">
                    <option disabled value="">— Выберите —</option>
                    <option v-for="org in organizations" :key="org.oid" :value="org.oid">
                        {{ org.name || org.ticker || org.oid }}
                    </option>
                </select>
            </label>
        </div>

        <div class="requirements__content" v-if="loading">
            <div class="skeleton"></div>
            <div class="skeleton"></div>
            <div class="skeleton short"></div>
        </div>

        <div class="requirements__empty" v-else-if="!selectedOid">
            Выберите организацию, чтобы просмотреть требования.
        </div>

        <div class="requirements__empty" v-else-if="!content">
            Для выбранной организации требования не найдены.
        </div>

        <article class="requirements__article" v-else>
            <div class="article" v-html="content"></div>
        </article>
    </section>
</template>

<script>
export default {
    name: 'Requirements',
    props: {
        organizations: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedOid: '',
            content: '',
            loading: false,
        };
    },
    async created() {
        if ((this.organizations || []).length > 0) {
            this.selectedOid = this.organizations[0].oid;
            await this.loadRequirements();
        }
    },
    methods: {
        async loadRequirements() {
            if (!this.selectedOid) return;
            this.loading = true;
            try {
                const org = (this.organizations || [])
                    .map((o) => ({
                        oid: o.oid,
                        ticker: o.ticker,
                        name: o.name,
                        technicalRequirements: o.technical_requirements ?? o.technicalRequirements,
                    }))
                    .find((o) => o.oid === this.selectedOid);
                this.content = org ? org.technicalRequirements || '' : '';
            } catch (e) {
                this.content = '';
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
/* Стили вынесены в resources/scss/requirements.scss */
</style>
